import { ApiBaseFront } from "../../front/api-base-front";

type Params = {
  kijshopCd: string,
  folderId: string,
  name: string,
  level: number,
  indexes: number,
  json?: {
    filename: string,
    body: string,
  }[],
  files?: {
    filename: string,
    data: Blob,
    kind: number,
  }[],
};

export class ApiPrintFavoriteProductRegister extends ApiBaseFront<{}> {
  constructor(param: Params) {
    const {
      kijshopCd,
      ..._param
    } = param;

    super(
      'POST',
      `/api/v1/print/shop/${kijshopCd}/favProduct`,
      'JSON',
      _param,
    );
  }
}
